
















































import { defineComponent, PropType, computed } from '@vue/composition-api'
import KaiMessage, { MessageType } from './KaiMessage.vue'

export default defineComponent({
  components: { KaiMessage },
  props: {
    title: {
      type: String,
      default: 'Form'
    },
    cancel: {
      type: Function as PropType<() => void>
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    canRemove: Boolean,
    remove: {
      type: Function as PropType<() => void>
    },
    removeText: {
      type: String,
      default: 'Delete'
    },
    save: {
      type: Function as PropType<() => void>
    },
    saveText: {
      type: String,
      default: 'Save'
    },
    messages: {
      type: Array as PropType<Array<string>>,
      default: () => []
    },
    messageType: {
      type: String as PropType<MessageType>,
      default: 'none'
    }
  },

  setup(props) {
    const hasMessages = computed(() => props.messages.length > 0)
    return {
      hasMessages
    }
  }
})
